import SvgCheckMark from 'creative-ui/uikit/svg/check-mark';
import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@/components/Typography/Text/Text';
import { commonTransComponents } from '@/i18n/translationsComponents';

const PASSKEY_CHECKMARK_KEYS = [
  'checkmarks.remember',
  'checkmarks.confirmation',
  'checkmarks.secure',
] as const;

const checkmarkIconStyle = {
  fill: 'var(--nj-semantic-color-text-status-planet-primary-default, #008480)',
  marginRight: 8,
  verticalAlign: 'middle',
} as const;

export function PasskeyCheckmarks({
  translationNamespace,
}: Readonly<{
  translationNamespace?: string;
}>) {
  const { t } = useTranslation(translationNamespace);

  return (
    <>
      {PASSKEY_CHECKMARK_KEYS.map((checkmarkKey) => (
        <Text key={checkmarkKey} align="center">
          <SvgCheckMark width={16} height={16} style={checkmarkIconStyle} />
          <Trans
            ns={translationNamespace}
            i18nKey={checkmarkKey}
            t={t}
            components={commonTransComponents}
          />
        </Text>
      ))}
    </>
  );
}
